<template>
  <q-dialog
    v-model="shown"
  >
    <q-card style="width: 700px; max-width: 90vw;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          {{ title }}
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <component
          :is="'report'"
          :system-report="SYSTEM_REPORTS.DATA_TABLE_TREND_REPORT"
          :options="reportOptions"
          :atlas="atlas"
        />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import { SYSTEM_REPORTS } from 'src/models/report/Report'
import { defineAsyncComponent } from 'vue'

export default {
  name: 'TrendReportDialog',
  components: {
    Report: defineAsyncComponent(() => import('src/modules/admin/report/Report'))
  },
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    title: {
      type: String,
      required: false,
      default: 'Trend Report'
    },
    reportOptions: {
      type: Object,
      required: true
    },
    atlas: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      shown: false
    }
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  created () {
    _.extend(this, { SYSTEM_REPORTS })
  },
  methods: {
    show () {
      this.shown = true
    }
  }
}
</script>
